export const API_URL = 'https://api.oleads.ai';

export const APP_ROUTE_PATH = '/app';
export const CAMPAIGNS_ROUTE_PATH = `${APP_ROUTE_PATH}/campaigns`;
export const NEW_CAMPAIGNS_ROUTE_PATH = `${CAMPAIGNS_ROUTE_PATH}/create`;
export const PROSPECTS_ROUTE_PATH = `${APP_ROUTE_PATH}/prospects`;
export const INBOX_ROUTE_PATH = `${APP_ROUTE_PATH}/inbox`;
export const PROFILE_ROUTE_PATH = `${APP_ROUTE_PATH}/profile`;
